module.exports = __webpack_public_path__ + "img/sn3.c45a803e.jpeg";